export default {
  meta: {
    title: '展位管理'
  }
};
